import { render, staticRenderFns } from "./PostBodyMarkdown.vue?vue&type=template&id=69d477f4"
import script from "./PostBodyMarkdown.vue?vue&type=script&lang=js"
export * from "./PostBodyMarkdown.vue?vue&type=script&lang=js"
import style0 from "./PostBodyMarkdown.vue?vue&type=style&index=0&id=69d477f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports